export class MESSAGE {
    static readonly ERROR_CONTACT_ADMIN = 'Please contact your system administrator.';
    static readonly ERROR_SET_VALUES = 'An error occurred while trying to set the values.';
    static readonly ERROR_ADD_RECORDS_TO_WORKLIST = 'An error occurred while trying to add records to the worklist.';
    static readonly ERROR_DELETE_RECORDS_TO_WORKLIST = 'An error occurred while trying to delete the record from the worklist.';
    static readonly ERROR_COMPARE_VALUES = 'An error occurred while trying to compare the values.';
}
